import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

// Keep in sync with benchling/analytics/lib/requests_analytics_event.py
export const REQUESTS_ANALYTICS_ACTIONS = {
  // READ actions
  OPENED_REQUESTS_DASHBOARD: {
    module: ANALYTICS_MODULE.REQUESTS,
    action: 'opened_requests_dashboard',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_REQUEST_DETAILS: {
    module: ANALYTICS_MODULE.REQUESTS,
    action: 'opened_request_details',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_COPY_REQUEST_MODAL: {
    module: ANALYTICS_MODULE.REQUESTS,
    action: 'opened_copy_request_modal',
    actionCategory: ACTION_CATEGORY.READ,
  },
  // WRITE actions
  CREATED_REQUEST: {
    module: ANALYTICS_MODULE.REQUESTS,
    action: 'created_request',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_REQUEST: {
    module: ANALYTICS_MODULE.REQUESTS,
    action: 'updated_request',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  ASSIGNED_REQUEST: {
    module: ANALYTICS_MODULE.REQUESTS,
    action: 'assigned_request',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  EXECUTED_REQUEST: {
    module: ANALYTICS_MODULE.REQUESTS,
    action: 'executed_request',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  COMPLETED_REQUEST: {
    module: ANALYTICS_MODULE.REQUESTS,
    action: 'completed_request',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_TASK: {
    module: ANALYTICS_MODULE.REQUESTS,
    action: 'created_task',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_TASK: {
    module: ANALYTICS_MODULE.REQUESTS,
    action: 'updated_task',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  EXECUTED_TASK: {
    module: ANALYTICS_MODULE.REQUESTS,
    action: 'executed_task',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  COMPLETED_TASK: {
    module: ANALYTICS_MODULE.REQUESTS,
    action: 'completed_task',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  DELETED_TASK: {
    module: ANALYTICS_MODULE.REQUESTS,
    action: 'deleted_task',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  ADDED_SAMPLE_GROUP: {
    module: ANALYTICS_MODULE.REQUESTS,
    action: 'added_sample_group',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  DELETED_SAMPLE_GROUP: {
    module: ANALYTICS_MODULE.REQUESTS,
    action: 'deleted_sample_group',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  IMPORTED_SAMPLE_GROUPS: {
    module: ANALYTICS_MODULE.REQUESTS,
    action: 'imported_sample_groups',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_TASK_SCHEMA: {
    module: ANALYTICS_MODULE.REQUESTS,
    action: 'created_task_schema',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_TASK_SCHEMA: {
    module: ANALYTICS_MODULE.REQUESTS,
    action: 'updated_task_schema',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  DELETED_FULFILLMENTS: {
    module: ANALYTICS_MODULE.REQUESTS,
    action: 'deleted_fulfillments',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
};
